// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as QueryString from "../../primitives/QueryString.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";

let baseRoute = "/suppliers";

function encoder(param) {
  return param.shopId;
}

function decoder(shopId) {
  return {
    TAG: "Ok",
    _0: {
      shopId: shopId
    }
  };
}

let value = JsonCodec.object1(encoder, decoder, JsonCodec.field("shopId", JsonCodec.string));

let CreateSupplierQueryStringCodecs = {
  encoder: encoder,
  decoder: decoder,
  value: value
};

function encodeCreateSupplierQueryString(state) {
  return QueryString.stringify(JsonCodec.encodeWith(state, value));
}

function decodeCreateSupplierQueryString(query) {
  let match = JsonCodec.decodeWith(QueryString.parse(query), value);
  if (match.TAG === "Ok") {
    return match._0.shopId;
  }
}

function showRoute(id) {
  return baseRoute + "/" + id;
}

function newRoute(shopId, param) {
  return baseRoute + "/new" + Stdlib_Option.mapOr(shopId, "", shopId => "?" + encodeCreateSupplierQueryString({
    shopId: shopId
  }));
}

function editRoute(id) {
  return showRoute(id) + "/edit";
}

function editLocationRoute(id) {
  return showRoute(id) + "/edit/location";
}

function editContactRoute(id) {
  return showRoute(id) + "/edit/contact";
}

export {
  baseRoute,
  CreateSupplierQueryStringCodecs,
  encodeCreateSupplierQueryString,
  decodeCreateSupplierQueryString,
  showRoute,
  newRoute,
  editRoute,
  editLocationRoute,
  editContactRoute,
}
/* value Not a pure module */
